var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vazzlkoida",
    d: "M0 0.111L17.218 0.111 17.218 12.735 0 12.735z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "724emii4yc",
    d: "M0.412 0.622L17.549 0.622 17.549 18.9 0.412 18.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(0 .789)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8ainwz1chb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vazzlkoida"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M15.867.111c-.746 0-1.352.66-1.352 1.472v1.192H12.38V1.583C12.38.77 11.773.11 11.028.11c-.745 0-1.352.66-1.352 1.472v1.192H7.542V1.583C7.542.77 6.936.11 6.19.11c-.745 0-1.352.66-1.352 1.472v1.192H2.704V1.583C2.704.77 2.097.11 1.352.11.606.111 0 .771 0 1.583v11.152h2.704v-1.782h2.134v1.782h2.704v-1.782h2.134v1.782h2.704v-1.782h2.135v1.782h2.703V1.583c0-.812-.606-1.472-1.351-1.472zM2.703 9.591h2.135V4.139H2.703V9.59zm4.84 0h2.133V4.139H7.542V9.59zm4.837 0h2.135V4.139H12.38V9.59z",
    mask: "url(#8ainwz1chb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(6.3 2.589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tjuo8ewovd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#724emii4yc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M7.453 13.19l-2.05 1.893.219 3.816H4.89l-.752-4.559 1.268-1.17 2.047.02zM17.55 5.727c0-.337-.124-.66-.342-.898l-1.353-1.473c-.277-.302-.65-.474-1.041-.485l-1.566-1.703c-.214-.233-.472-.407-.754-.512-.334-.124-.693.107-.792.475.335.144.627.385.844.696l.725 1.042h-1.612l.275.443c.281.452.75.722 1.251.722h.08l-1.642 2.932H4.338c-.799 0-1.564.355-2.117.981l-.025.027L.78 7.195c-.169-.093-.368.04-.368.247v.072c0 .305.085.604.244.855l.61.968.485 2.568-.536.874.767 6.12h.732l-.002-3.815 2.549-2.352 4.79.047v6.12h.707l.365-4.247 1.656-1.796c1.008-1.093 1.685-2.496 1.943-4.02l.417-2.469h.67l.43.936c.146.32.446.521.774.521v-1.46c.3-.028.536-.303.536-.637zm-5.563 8.606l.91 4.566h.732l-.834-5.443-.808.877z",
    mask: "url(#tjuo8ewovd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M21.818 6.873c0 .187-.14.339-.312.339s-.311-.152-.311-.34c0-.187.14-.338.311-.338.172 0 .312.151.312.339",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.52f8c535006df6833e2130609070e37d.svg";
export { ForwardRef as ReactComponent };